var exports = {
  "k": "xe533113f--797c01--container",
  "i": "xe533113f--797c01--wrapper",
};

module.exports = exports;
